import { render, staticRenderFns } from "./KitDetailsModal.vue?vue&type=template&id=a10a448e"
import script from "./KitDetailsModal.vue?vue&type=script&lang=js"
export * from "./KitDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports